export enum FontFamily {
  OpenSans = 'Open Sans',
  ADNOCSans = 'ADNOC Sans',
  SegoeUI = 'Segoe UI',
}

export const FONT_FROM_COMPANY = {
  adnoc: FontFamily.ADNOCSans,
  dge: FontFamily.SegoeUI,
};

export const FONT_FROM_COMPANY_DEFAULT = FontFamily.OpenSans;
